

import { IsReturningCustomerPayloadModel } from "./interface/isReturningCustomer/isReturningCustomerInterface";
import { apiRequest2 } from "../../api/apiRequest";
import { startLoader, stopLoader } from "../../util/loader";
import { normalizeKeys, removeNullAndEmpty, storeFailedResponse } from "./helperModules/helperFunctions";
import { isReturningCustomerDataKeys  } from "./keys/isReturningCustomerKeys";
import { successLogger } from "../../api/apiTester";

export function isValidIsReturningCustomerPayload(payload: any): payload is IsReturningCustomerPayloadModel {
    let payloadLower = JSON.parse(JSON.stringify(normalizeKeys(payload)));
        payloadLower = JSON.parse(JSON.stringify(removeNullAndEmpty(payloadLower)));
        
        if (!payloadLower || typeof payloadLower !== 'object') {
            return false;
        }

        //checking if all mandatory fields are present
        const mandatoryFields = ['conceptId', 'weblocationId'];
        const hasAllMandatoryFields = mandatoryFields.every(field => payloadLower?.hasOwnProperty(normalizeKeys(field)));
        if (!hasAllMandatoryFields) return false;

        //checking if any invalid keys are present
        const hasInvalidKeys = Object.keys(payloadLower).some((key) => {
          if(!isReturningCustomerDataKeys.hasOwnProperty(key)){
            console.error('Invalid key in isReturningCustomer Payload:', key);
            return true;
          }
        });
        if (hasInvalidKeys) return false;

        const hasInvalidTypes = Object.entries(payloadLower).some(([key, value]) => {
            if (value === undefined) {
              console.error('Undefined value in isReturningCustomer Payload:', key);
              return true;
            }
            console.log(typeof value, isReturningCustomerDataKeys[key],"Value:",value,"Key:",key);
            return typeof value !== isReturningCustomerDataKeys[key];
        });

        if (hasInvalidTypes) return false;
        return payload;
}

export async function isReturningCustomerWrapper(url: string, payload: any) {
  const suLogger = localStorage.getItem("suLogger") === 'true';

  const enableStrictValidation = process.env.ENABLE_STRICT_PAYLOAD_VALIDATION?.toLowerCase() === 'true';
  if (enableStrictValidation && !isValidIsReturningCustomerPayload(payload)) {
    console.error("Invalid payload for isReturningCustomer Endpoint:", payload);
    throw new Error(`Invalid payload: ${JSON.stringify(payload)}`);
  }
  const normalizedPayload = normalizeKeys(payload);
  const request = {
    method: 'POST',
    url,
    data: normalizedPayload,
  };

  try {
    startLoader();
    const response = await apiRequest2(request);
    successLogger(request.data, request.url, suLogger, response);
    return response;
  } catch (err: any) {
    console.error('Error in isReturningCustomerWrapper:', err);
    storeFailedResponse(request, err);
    throw new Error(`isReturningCustomerWrapper failed: ${err.message || err}`);
  } finally {
    stopLoader();
  }
}